// extracted by mini-css-extract-plugin
export default {"healthCareWrapper":"myHealthCare_healthCareWrapper__YBYho","healthCareHeader":"myHealthCare_healthCareHeader__NxMD9"};